import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { ChefHat, Users, ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ACCOUNTS = [
  {
    id: "customer",
    title: "Customer",
    tagline: "Subscribe, curate menus, track your chef.",
    email: "customer@delcocefs.in",
    password: "customer123",
    redirect: "/app",
    icon: Users,
    color: "bg-primary/10 text-primary",
  },
  {
    id: "chef",
    title: "Chef",
    tagline: "Clock in, post selfies, close slots.",
    email: "chef@delcocefs.in",
    password: "chef123",
    redirect: "/chef",
    icon: ChefHat,
    color: "bg-secondary/15 text-secondary",
  },
  {
    id: "admin",
    title: "Admin",
    tagline: "Map chefs, calendars, live locations.",
    email: "admin@delcocefs.in",
    password: "admin123",
    redirect: "/admin",
    icon: ShieldCheck,
    color: "bg-accent text-accent-foreground",
  },
];

export default function Personas() {
  const { login, logout } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(null);

  const enter = async (acc) => {
    setBusy(acc.id);
    logout();
    const res = await login(acc.email, acc.password);
    setBusy(null);
    if (!res.ok) { toast.error(res.error); return; }
    toast.success(`Signed in as ${acc.title}`);
    nav(acc.redirect);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 py-14">
        <div className="text-center max-w-2xl mx-auto anim-fade-up">
          <span className="inline-block text-xs uppercase tracking-[0.2em] font-bold text-primary mb-4">Demo · One-click access</span>
          <h1 className="heading text-4xl sm:text-5xl font-bold leading-tight">Pick a persona to explore</h1>
          <p className="text-muted-foreground mt-3">Three roles, one app. Each card signs you in instantly with a seeded test account.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {ACCOUNTS.map((acc, i) => {
            const Icon = acc.icon;
            const isBusy = busy === acc.id;
            return (
              <div key={acc.id} className="card-default flex flex-col anim-fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`persona-${acc.id}`}>
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${acc.color}`}>
                  <Icon size={22} strokeWidth={1.5} />
                </div>
                <h3 className="heading text-2xl font-semibold mt-5">{acc.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{acc.tagline}</p>

                <div className="mt-5 p-3 rounded-xl bg-muted text-xs space-y-0.5">
                  <div><span className="text-muted-foreground">email · </span><b>{acc.email}</b></div>
                  <div><span className="text-muted-foreground">pass · </span><b>{acc.password}</b></div>
                </div>

                <Button
                  onClick={() => enter(acc)}
                  disabled={isBusy}
                  className="rounded-full bg-primary hover:bg-primary/90 mt-5 w-full"
                  data-testid={`enter-${acc.id}`}
                >
                  {isBusy ? <><Loader2 size={16} className="mr-2 animate-spin"/>Signing in…</> : `Enter as ${acc.title}`}
                </Button>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10 text-sm text-muted-foreground">
          Or sign in normally → <Link to="/login" className="text-primary font-medium">/login</Link>
        </div>
      </div>
    </div>
  );
}
